// app/the-killers/songs.ts

export const songs = [
  {
    id: 1,
    title: 'Mr Brightside',
    audioFile:
      'https://lhqbqmtdlyyvszfmlwma.supabase.co/storage/v1/object/public/songs/mr-brightside.m4a',
  },
  {
    id: 2,
    title: 'When You Were Young',
    audioFile:
      'https://lhqbqmtdlyyvszfmlwma.supabase.co/storage/v1/object/public/songs/when-you-were-young.m4a',
  },
  {
    id: 3,
    title: 'Human',
    audioFile:
      'https://lhqbqmtdlyyvszfmlwma.supabase.co/storage/v1/object/public/songs/human.m4a',
  },
  {
    id: 4,
    title: 'Runaways',
    audioFile:
      'https://lhqbqmtdlyyvszfmlwma.supabase.co/storage/v1/object/public/songs/runaways.m4a',
  },
  {
    id: 5,
    title: 'Run for Cover',
    audioFile:
      'https://lhqbqmtdlyyvszfmlwma.supabase.co/storage/v1/object/public/songs/run-for-cover.m4a',
  },
  {
    id: 6,
    title: 'Caution',
    audioFile:
      'https://lhqbqmtdlyyvszfmlwma.supabase.co/storage/v1/object/public/songs/caution.m4a',
  },
  {
    id: 7,
    title: 'Quiet Town',
    audioFile:
      'https://lhqbqmtdlyyvszfmlwma.supabase.co/storage/v1/object/public/songs/quiet-town.m4a',
  },
];
